var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    style: {
      enableBackground: "new 0 0 640 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DBC8B6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.8,40.8l-128,448c-4.9,17-22.6,26.8-39.6,22c-17-4.9-26.8-22.6-22-39.6l128-448c4.9-17,22.6-26.8,39.6-22 C409.8,6.1,419.6,23.8,414.8,40.8L414.8,40.8z M518.6,121.4l112,112c12.5,12.5,12.5,32.7,0,45.2l-112,112 c-12.5,12.5-32.7,12.5-45.2,0s-12.5-32.7,0-45.2l89.3-89.4l-89.3-89.4c-12.5-12.5-12.5-32.7,0-45.2S506.1,108.9,518.6,121.4 L518.6,121.4z M166.6,166.6L77.2,256l89.4,89.4c12.5,12.5,12.5,32.7,0,45.2s-32.7,12.5-45.2,0l-112-112c-12.5-12.5-12.5-32.7,0-45.2 l112-112c12.5-12.5,32.7-12.5,45.2,0S179.1,154.1,166.6,166.6L166.6,166.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSolid);
export default __webpack_public_path__ + "static/media/code-solid.052f55b687cbb954c2bded156d2d1e28.svg";
export { ForwardRef as ReactComponent };